module.exports = __webpack_public_path__ + "static/media/IMG_3506_sm.67134821.jpg";